export default {
  name: 'Listagem de Movimentos',
  children: [
    {
      name: 'Lançamentos Únicos',
      value: 'lancamento-unico',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Lançamentos Constantes',
      value: 'lancamento-constante',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Faltas',
      value: 'faltas',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Alterações Salariais',
      value: 'alteracao-salarial',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Afastamento',
      value: 'afastamento',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Lançamentos de Nota Fiscal por Tomador',
      value: 'lancamento-nf-tomador',
      options: {
        showDateMonthPeriod: true,
      },
    },
  ],
};
